// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { AcceptableUsePolicyPage } from '../pages/AcceptableUsePolicyPage/AcceptableUsePolicyPage';

export const Route = createFileRoute('/acceptable-use-policy')({
  component: AcceptableUsePolicyPage,
});
